/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-23 21:55:03
 * @LastEditTime: 2022-01-29 12:28:39
 * @LastEditors: zhao - 🍉
 * @Description: 管家列表
 * @FilePath: /zhzj-admin/src/page/HouseKeep/index.jsx
 */
import { Divider } from 'antd';
import React from 'react'
import { commonIsMap } from '../../axios/dictionaries';
import AuthButton from '../../components/AuthButton/AuthButton';
import PageWrap from '../../components/PageWrap'
import TableHelper from '../../components/TableHelper'
import { fetchHouseKeepList,  } from "../../services/housekeep";
import { formatTime } from '../../utils';
import HouseKeepDetail from './detail';
const HouseKeep = (props) => {

    let HouseKeepDetailRef = null 


  

    const searchOptions = [
        { key: 'faceDetected', type: 'select', options: commonIsMap, placeholder: '人脸认证' },
        { key: 'realNameIdentified', type: 'select', options: commonIsMap, placeholder: '实名认证' },
        { key: 'keyword', type: 'input', placeholder: '姓名/手机号/身份证'}
    ]
    const columns = [
        { title: '证件姓名', dataIndex: 'credentialName', },
        { title: '证件号码', dataIndex: 'credentialNumber', },
        { title: '人脸识别时间', dataIndex: 'faceDetected', render: (text,record) => {
            return text === true ? formatTime(record.faceDetectedTime) : '未识别'
        }},
        { title: '实名认证时间', dataIndex: 'realNameIdentified', render: (text, record) => {
            return text === true ? formatTime(record.nameIdentifiedTime) : '未识别'
        }},
        { title: '创建时间', dataIndex: 'createTime', render: formatTime},
        { title: '操作', dataIndex: 'actions', render: (text, record) => {
            return <React.Fragment>
                <AuthButton authkey="b-2-1">
                    <a onClick={() =>HouseKeepDetailRef.open(record.id)}>详情</a>
                    <Divider type="vertical" />
                </AuthButton>
               
            </React.Fragment>
        } }
    ]
    return (
        <PageWrap>
            <TableHelper searchOptions={searchOptions} columns={columns} request={fetchHouseKeepList} />
            <HouseKeepDetail getRef={ref => HouseKeepDetailRef = ref} />
        </PageWrap>
    )
}

export default HouseKeep 


// WEBPACK FOOTER //
// ./src/page/HouseKeep/index.jsx